<script>

    import trans from '../mixins/trans';

    const axios = require('axios');

    export default {

        mixins: [
            trans
        ],

        props: [
            'itemId',
            'trainingId',
            'initialPassed',
            'initialProgress',
            'isLeaf'
        ],

        data() {
            return {
                progress: 0,
                passed: false
            };
        },

        mounted() {
            this.progress = Math.floor(this.initialProgress);

            if (this.initialPassed === true || this.initialPassed === 1 || this.initialPassed === '1' ) {
                this.passed = true;
            }

            this.sendProgress();
        },

        computed: {
            progressText() {
                return Math.floor(this.progress) + ' %';
            },

            startChapterText() {
                if(!this.isLeaf){
                    if(this.progress == 0){
                        return this.__('Start Chapter');
                    }
                    else if(this.passed){
                        return this.__('Repeat Chapter');
                    }
                    else{
                        return this.__('Continue Chapter');
                    }
                }else{
                    if(this.progress == 0){
                        return this.__('Start Content');
                    }
                    else if(this.passed){
                        return this.__('Repeat Content');
                    }
                    else{
                        return this.__('Continue Content');
                    }
                }
            },

            startText() {
                if(this.progress == 0){
                    return this.__('Start Training');
                }
                else if(this.passed){
                    return this.__('Repeat Training');
                }
                else{
                    return this.__('Continue Training');
                }
            }
        },

        methods: {

            refreshProgress(items) {
                if (typeof(this.itemId) !== "undefined" && typeof(items)==="object") {
                    if (items.id==this.itemId) {
                        let itemNbr = items.children.length;
                        if (itemNbr === 0){
                            return;
                        }
                        if (itemNbr === 1) {
                            this.progress = items.children[0].isPassed ? 100 : Math.floor(items.children[0].progressScore);
                            return;
                        } else {
                            let passedNbr = 0;
                            let score = 0
                            items.children.forEach(function (child) {
                                if(child.isPassed){
                                    passedNbr++;
                                    score += 100;
                                } else {
                                    score += parseFloat(child.progressScore);
                                }
                            });
                            // this.progress = Math.floor(passedNbr/itemNbr*100);
                            this.progress = Math.floor(score/itemNbr);
                            return;
                        }
                    }

                    if (items.type==="collection" && items.children.length) {
                        for (let i = 0; i < items.children.length; i++) {
                            let child = items.children[i];
                            if(child.id==this.itemId){
                                this.progress = Math.floor(child.progressScore);
                                return;
                            }
                        }
                    }

                    return;
                }

                let url = `/api/scorm/progress/${this.trainingId}`;

                if (this.itemId) {
                    url += `/${this.itemId}`;
                }

                axios.get(url)
                    .then(response => {
                        this.progress = Math.floor(response.data.progress);
                        this.passed = response.data.hasPassed;
                        if(response.data.presentRating){
                            $('#flashRatingModalCenter').modal('show');
                        }
                        this.sendProgress();
                    });
            },

            sendProgress() {
                if (!!window.SCORM && !!this.trainingId && !this.itemId) {
                    if (this.passed) {
                        window.SCORM.progress(100);
                    } else {
                      window.SCORM.progress(this.progress);
                    }
                }
            }

        }

    }

</script>